import React from 'react';
import { Container, Grid, Typography } from '@material-ui/core';
import { useStyles, IntegrityPillarsLogic } from './integrityPillars.module';
import IntegrityCard from '../integrityCard/integrityCard';

const IntegrityPillars = () => {
  const classes = useStyles();
  const { translator } = IntegrityPillarsLogic();

  const pillars = [
    {
      id: 'technology',
      title: translator('integrityPillarsTechnologyCard.title'),
      description: translator('integrityPillarsTechnologyCard.description'),
    },
    {
      id: 'science',
      title: translator('integrityPillarsScienceCard.title'),
      description: translator('integrityPillarsScienceCard.description'),
    },
    {
      id: 'compliance',
      title: translator('integrityPillarsComplianceCard.title'),
      description: translator('integrityPillarsComplianceCard.description'),
    },
    {
      id: 'finance',
      title: translator('integrityPillarsFinanceCard.title'),
      description: translator('integrityPillarsFinanceCard.description'),
    },
  ];

  return (
    <Container maxWidth="lg" className={classes.root}>
      <div className={classes.header}>
        <div className={classes.headerContent}>
          <Typography component="span" className={classes.eyebrow}>
            {translator('integrityPillars.eyebrow')}
          </Typography>

          <Typography component="h2" className={classes.title}>
            {translator('integrityPillars.title')}
          </Typography>
        </div>

        <Typography component="p" className={classes.description}>
          {translator('integrityPillars.description')}
        </Typography>
      </div>

      <Grid container spacing={3} className={classes.cards}>
        {pillars.map((pillar) => (
          <Grid item xs={12} sm={6} md={3} key={pillar.id}>
            <IntegrityCard
              title={pillar.title}
              description={pillar.description}
              className={classes.cardItem}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default IntegrityPillars;
